import { combineReducers } from 'redux';
import {
  authReducer,
  otpverifyReducer,
  resendReducer,
  renewTokenReducer,
  verifyTokenReducer,
  acceptInvitationReducer,
  registerTenantReducer,
  verifyRegistrationReducer,
  checkTenantExistsReducer,
  logoutReducer,
  revokeDeviceSessionReducer,
} from './authReducer';
import { commonReducer, createServiceReducer, deleteServiceReducer, fileUploadUserReducer, getServiceParamsReducer, getServiceReducer, getServiceViewReducer, sendemailReducer, serviceToggleReducer ,  getPrivacyPolicyReducer , getTermsOfServiceReducer } from './commonReducer';
import { 
    getProfileReducer, roleDataReducer, 
    updateProfileImageReducer, updateProfileReducer, userCreateReducer, 
    userListReducer, userUpdateReducer, userViewReducer, getTermsByTypeReducer,
    getInstructorHistoryReducer ,sendInvitationReducer } from './userReducer';
import { createCategoryReducer, deleteCateoryReducer, getCategoryParamsReducer, getCategoryReducer, toggleCategoryReducer, viewCategoryReducer } from './categoryReducer';
import { createVehicleReducer, deleteVehicleReducer, getVehicleParamsReducer, getVehicleReducer, toggleVehicleReducer, vehicleViewReducer, uploadVehicleReducer, tripSheetSaveReducer, tripSheetListReducer, tripSheetViewReducer, tripSheetDeleteReducer, tripSheetByVehicleReducer, tripSheetByBatchReducer } from './vehicleReducer';
import { createEnrollmentReducer, deleteEnrollmentReducer, exportEnrollmentReducer, getEnrollmentParamsReducer, getEnrollmentReducer, getEnrollmentViewReducer, toggleEnrollmentReducer, assignApplicationReducer } from './enrollmentReducer';
import { createBatchReducer, deleteBatchReducer, getAvailableStudentsReducer, getAvailableUsersReducer, getBatchParamsReducer, 
    getBatchReducer, markAttendanceReducer, toggleBatchReducer, viewBatchReducer, getBatchHistoryReducer, getOverallStudentAnalyticsReducer, getSessionAnalyticsReducer, getAvailableStudentsForBatchReducer ,getCalendarDetailsReducer} from './batchReducer';
import { createExpenseReducer, deleteExpenseReducer, getExpenseParamsReducer, getExpenseReducer, getExpenseViewReducer } from './expenseReducer';
import { createFeeReducer, deleteFeeReducer, getFeeParamsReducer, getFeeReducer, getFeeViewReducer, getStudentFeeSummaryReducer, getEnrollmentFeeHistoryReducer, exportFeeReducer } from './feeReducer';
import { getQueryReducer, createQueryReducer, viewQueryReducer, deleteQueryReducer, addRemarksReducer } from './queryReducer';
import { getLeadReducer, createLeadReducer, viewLeadReducer, updateLeadReducer, deleteLeadReducer, addFollowUpReducer } from './leadReducer';
import { getCommonReportsReducer, getRevenueReportReducer, getStudentReportReducer, getInstructorReportReducer } from './dashboardReducer';
import { getPreferenceReducer, getPreferenceByPhoneReducer, savePreferenceReducer } from './preferenceReducer';
import { deleteFilesReducer  } from './commonReducer';
import {
    getSubscriptionPlanReducer, createSubscriptionReducer,
    subscriptionStatusReducer, orderStatusReducer, syncPlansReducer,
    getAllPlansReducer, userSubscriptionStatusReducer,
    listAdminPlansReducer, viewAdminPlanReducer, saveAdminPlanReducer, deleteAdminPlanReducer, getRoutesReducer,
    getSubscriptionSyncStatusReducer,getInvoiceReducer, getAllInvoicesReducer,getInvoicePDFReducer,getOverallInvoicesReducer
} from './subscriptionReducer';
import { getTenantListReducer, getHeaderTenantListReducer, saveTenantReducer, viewTenantReducer, getAccessControlReducer, saveAccessControlReducer } from './tenantReducer';
import { switchTenantReducer, enableBranchesReducer, listBranchesReducer, createBranchReducer } from './branchReducer';
import { listTrackingSessionsReducer, viewTrackingSessionReducer, activeTrackingSessionsReducer, batchTodaySessionReducer, historyListReducer, viewSessionStudentsReducer, generateShareTokenReducer, disableShareReducer, shareStatusReducer } from './trackingReducer';
import { listReviewsReducer, getInstructorRatingsReducer, getSchoolRatingsReducer, deleteReviewReducer, viewReviewReducer , getSchoolByRatingsReducer } from './reviewReducer';

const rootReducer = combineReducers({
    authReducer, resendReducer, otpverifyReducer, revokeDeviceSessionReducer,
    renewTokenReducer, commonReducer, roleDataReducer, getPrivacyPolicyReducer, getTermsOfServiceReducer,
    verifyTokenReducer, acceptInvitationReducer,createCategoryReducer,
    getCategoryParamsReducer,deleteCateoryReducer,toggleCategoryReducer,viewCategoryReducer,getServiceParamsReducer,
    getServiceViewReducer,createServiceReducer,serviceToggleReducer,deleteServiceReducer,
    
    //enrollment reducers
    getEnrollmentReducer, getEnrollmentParamsReducer, createEnrollmentReducer, 
    deleteEnrollmentReducer, getEnrollmentViewReducer, toggleEnrollmentReducer, exportEnrollmentReducer,
    assignApplicationReducer,
    
    //user reducers
    userCreateReducer, userListReducer, userUpdateReducer,
    userViewReducer, getServiceReducer, getCategoryReducer,
    // vehicle reducers
    getVehicleReducer, getVehicleParamsReducer, createVehicleReducer,
    deleteVehicleReducer, vehicleViewReducer, toggleVehicleReducer,
    uploadVehicleReducer,logoutReducer,
    // trip sheet reducers
    tripSheetSaveReducer, tripSheetListReducer, tripSheetViewReducer,
    tripSheetDeleteReducer, tripSheetByVehicleReducer, tripSheetByBatchReducer,
    
    // batch reducers
    getBatchReducer, getBatchParamsReducer, createBatchReducer,
    deleteBatchReducer, toggleBatchReducer, viewBatchReducer,
    getBatchHistoryReducer,getOverallStudentAnalyticsReducer, getSessionAnalyticsReducer, getAvailableStudentsForBatchReducer,getCalendarDetailsReducer,
    
    getProfileReducer, updateProfileReducer, updateProfileImageReducer,
    getAvailableUsersReducer,
    getAvailableStudentsReducer, markAttendanceReducer,
    getTermsByTypeReducer,fileUploadUserReducer,
    
    // expense reducers
    getExpenseReducer, getExpenseParamsReducer, createExpenseReducer,
    deleteExpenseReducer, getExpenseViewReducer ,

    // fee reducers
    getFeeReducer, getFeeParamsReducer, createFeeReducer,
    deleteFeeReducer, getFeeViewReducer, getStudentFeeSummaryReducer,
    getEnrollmentFeeHistoryReducer, exportFeeReducer,
 
    // query reducers
    getQueryReducer, createQueryReducer, viewQueryReducer, deleteQueryReducer, addRemarksReducer,

    // lead reducers
    getLeadReducer, createLeadReducer, viewLeadReducer, updateLeadReducer, deleteLeadReducer, addFollowUpReducer,
    
    //dashboard reducers
    getCommonReportsReducer, getRevenueReportReducer, getStudentReportReducer, getInstructorReportReducer,
   
    //common reducers
    getPreferenceReducer, getPreferenceByPhoneReducer, savePreferenceReducer,deleteFilesReducer,
    
    // subscription reducers
    getSubscriptionPlanReducer, createSubscriptionReducer,
    subscriptionStatusReducer, orderStatusReducer, syncPlansReducer, getAllPlansReducer,
    userSubscriptionStatusReducer,getSubscriptionSyncStatusReducer,
    listAdminPlansReducer, viewAdminPlanReducer, saveAdminPlanReducer, deleteAdminPlanReducer, getRoutesReducer,
    getInvoiceReducer, getAllInvoicesReducer,getInvoicePDFReducer,getOverallInvoicesReducer,

    //tenant reducers
    registerTenantReducer, verifyRegistrationReducer, checkTenantExistsReducer,
    getTenantListReducer, getHeaderTenantListReducer, saveTenantReducer, viewTenantReducer, sendemailReducer,
    getAccessControlReducer, saveAccessControlReducer,

    //tenant switch & branch reducers
    switchTenantReducer, enableBranchesReducer, listBranchesReducer, createBranchReducer,

    // instructor history reducer
    getInstructorHistoryReducer,sendInvitationReducer,

    // tracking reducers
    listTrackingSessionsReducer,
    viewTrackingSessionReducer,
    activeTrackingSessionsReducer,
    batchTodaySessionReducer,
    historyListReducer,
    viewSessionStudentsReducer,
    generateShareTokenReducer,
    disableShareReducer,
    shareStatusReducer,

    // review reducers
    getSchoolByRatingsReducer,
    listReviewsReducer,
    getInstructorRatingsReducer,
    getSchoolRatingsReducer,
    deleteReviewReducer,
    viewReviewReducer,
});

export default rootReducer;